/* eslint-env browser */
import * as ActionTypes from 'actions';

const initialState = {
  isLoading: true,
  id: '',
  email: '',
  first_name: '',
  last_name: '',
  terms_agree: false,
  'g-recaptcha-response': '',
};

export default function(state = initialState, action = {}) {
  const { type, response, error } = action;

  switch (type) {

  case ActionTypes.SIGNUP_LOAD_REQUEST:
  case ActionTypes.SIGNUP_REQUEST:
    return { ...state, isLoading: true };

  case ActionTypes.SIGNUP_LOAD_SUCCESS:
  case ActionTypes.SIGNUP_SUCCESS:
    return { ...state, isLoading: false, ...response };

  case ActionTypes.SIGNUP_LOAD_FAILURE:
  case ActionTypes.SIGNUP_FAILURE:
    return { ...state, isLoading: false };

  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/reducers/signup.js